import { BusinessObjectBase } from './base';
import type { ServiceTask } from './service-task';

export interface ServiceTaskHistoryData {
  readonly id: string;
  readonly eventType: string;
  readonly data?: any;
  readonly timestamp?: Date;
  readonly serviceTaskId: number;
  readonly serviceTask?: ServiceTask;
}

export interface ServiceTaskHistory extends Readonly<ServiceTaskHistoryData> {}
export class ServiceTaskHistory extends BusinessObjectBase {
  static readonly entityName = 'ServiceTaskHistory' as const;
  static readonly plural = 'service-task-histories';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<ServiceTaskHistory[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new ServiceTaskHistory(data));
  }

  static async findOne(filter?: any): Promise<ServiceTaskHistory | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new ServiceTaskHistory(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<ServiceTaskHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new ServiceTaskHistory(data);
  }

  static async create(
    data: Omit<ServiceTaskHistoryData, 'id'>,
  ): Promise<ServiceTaskHistory> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new ServiceTaskHistory(result);
  }

  static async updateById(
    id: string,
    data: Partial<ServiceTaskHistoryData>,
  ): Promise<ServiceTaskHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new ServiceTaskHistory(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
